<template>
  <div
    class="relative h-full max-h-full overflow-hidden bg-repeat scene"
    :style="{ backgroundImage: 'url(' + require('@assets/images/bg-pattern-1.png') + ')' }"
  >
    <slot />
    <!--end::content-->

    <component :is="item.component" v-for="(item, index) of extend" :key="index" v-bind="bindProperties" />
    <!--end::extends-->
  </div>
</template>

<script>
export default {
  props: {
    extend: {
      type: Array,
      required: false,
      default: () => [],
    },
  },
  computed: {
    bindProperties() {
      return {
        parent: this,
      }
    },
  },
}
</script>
